import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import RebateHeaderIcon from '../../icons/icon-rebate-modal-header.svg';
import InfoModal from '../InfoModal/InfoModal';
import getPriceDisplay from '../../helpers/getPriceDisplay';
import getCommodityValue from '../../helpers/getCommodityValue';
import CommodityIcon from '../CommodityIcon/CommodityIcon';
import GiftIcon from '../../icons/icon-free-gift-with-purchase.svg';
import ProgramAddOn from './components/ProgramAddOn';


const PriceDisplay = function PriceDisplayComponent({
  addOns,
  price,
  rebates,
  rebatePrice,
  promotions,
}) {
  const {
    onSale,
    hasRebates,
    salesPriceDisplay,
    retailPriceDisplay,
    rebatePriceDisplay,
    addOnPriceDisplay,
  } = getPriceDisplay(price, rebatePrice, addOns);

  const renderAddOns = addOns => (
      <>
      {addOns && addOns.map((addOn) => {
        const Component = {
          program: ProgramAddOn,
        }[addOn.type];

        if (Component) {
          return <Component key={addOn.id} addOn={addOn} price={addOnPriceDisplay[addOn.id]} rebatePrice={rebatePrice} newPrice={price} />;
        }

        return null;
      })}
    </>
    );
  const renderPromotions = (promotions) => {
    if (!promotions) {
      return null;
    }

    return promotions.map((promotion) => {
      const {
        uuid,
        modalTrigger,
        modalHeadingSmall,
        modalHeadingLarge,
        modalMarkdown,
        modalContentLabel,
      } = promotion;

      return (
        <div className="marketplace-tooltip__promotion-header" key={uuid}>
          <InfoModal
            styleFlag="promotion"
            message={modalMarkdown}
            contentLabel={modalContentLabel}
            subheader={modalHeadingSmall}
            header={modalHeadingLarge}
            headerIcon={<GiftIcon />}
          >
            {modalTrigger}
          </InfoModal>
        </div>
      );
    });
  };

  if (hasRebates) {
    const commodityValue = getCommodityValue();
    const isCombinedCommodity = commodityValue === 'combined';

    const commodityIconClass = classNames('price-display__commodity-icon', {
      'price-display__commodity-icon--double': isCombinedCommodity,
      'price-display__commodity-icon--single': !isCombinedCommodity,
    });

    const rebateTooltipLabel = commodityValue ? `${commodityValue} ${rebates.label}` : rebates.label;

    return (
      <>
        <div className="price-display__retail">{retailPriceDisplay}</div>
        <div className="price-display__rebate">
          <div className="price-display__rebate-header">
            <CommodityIcon
              className={commodityIconClass}
              commodityValue={commodityValue}
            />
            <div className="price-display__rebate-price">
              {rebatePriceDisplay}
            </div>
          </div>
          <div className="price-display__rebate-description">
            {'Your price after '}
            <InfoModal
              styleFlag="rebate"
              message={rebates.tooltip}
              contentLabel="Instant Rebates"
              subheader="You may be eligible for"
              header="Instant rebates!"
              headerIcon={<RebateHeaderIcon />}
            >
              {rebateTooltipLabel}
            </InfoModal>
          </div>
          {renderAddOns(addOns)}
          {renderPromotions(promotions)}
        </div>
      </>
    );
  }


  return (
    <>
      {onSale && <div className="price-display__retail">{retailPriceDisplay}</div>}
      <div className="price-display__total">
        {salesPriceDisplay}
        {onSale && <span className="price-display__sale">&nbsp;on sale</span>}
        {renderAddOns(addOns)}
        {renderPromotions(promotions)}
      </div>
    </>
  );
};

PriceDisplay.propTypes = {
  addOns: PropTypes.arrayOf(PropTypes.shape({
    values: PropTypes.shape({
      maxAddOnPrice: PropTypes.number,
      minAddOnPrice: PropTypes.number,
    }),
    content: PropTypes.shape({
      modalBody: PropTypes.string,
      title: PropTypes.string,
      productCardPrefix: PropTypes.string,
      productCardModalTrigger: PropTypes.string,
      productCardSuffix: PropTypes.string,
      icon: PropTypes.string,
    }),
    type: PropTypes.string,
  })),
  price: PropTypes.shape({}).isRequired,
  rebates: PropTypes.shape({
    label: PropTypes.string,
    tooltip: PropTypes.string,
  }).isRequired,
  promotions: PropTypes.arrayOf(PropTypes.shape({
    uuid: PropTypes.string,
    modalTrigger: PropTypes.string,
    modalHeadingSmall: PropTypes.string,
    modalHeadingLarge: PropTypes.string,
    modalMarkdown: PropTypes.string,
    modalContentLabel: PropTypes.string,
  })),
  rebatePrice: PropTypes.shape({}),
};

PriceDisplay.defaultProps = {
  addOns: null,
  promotions: null,
  rebatePrice: null,
};

export default PriceDisplay;
